import Header from "../components/global/Header";
import Content from "./Content";
import '../styles/privateRoute.css';
import { Navigate, useLocation } from "react-router-dom";

export default function PrivateRoute() {
  const token = localStorage.getItem("token");
  const user = localStorage.getItem("user");
  const role = localStorage.getItem("role");
  const isAuthenticated = !!token;
  const location = useLocation();

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  if (role === "driver" && location.pathname !== "/supplies") {
    return <Navigate to="/supplies" replace />;
  }

  return (
    <div className="privateBody">
        <Header role={role}/>
        <Content user={user}/>
    </div>
  );
}
